import { createIcon } from '../createIcon';

export const OutlinedWindowRestoreIconConfig = {
  name: 'OutlinedWindowRestoreIcon',
  height: 512,
  width: 512,
  svgPath: 'M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const OutlinedWindowRestoreIcon = createIcon(OutlinedWindowRestoreIconConfig);

export default OutlinedWindowRestoreIcon;